import { useEffect, useRef, useState } from "react";
import io from "socket.io-client";
import useCurrentUser from "../../useCurrentUser";
import useUrls from "../../useUrls";
import useUserTeam from "../useUserTeam";
import useDraft from "./useDraft";
import useDraftMessages from "./useDraftMessages";

// noinspection JSUndefinedPropertyAssignment,JSUndefinedPropertyAssignment,JSCheckFunctionSignatures
export default function useDraftChat() {
  const currentUser = useCurrentUser();
  const { draftData } = useDraft();
  const { draftMessagesData } = useDraftMessages();
  const userTeam = useUserTeam();
  const [fromTeamId, setFromTeamId] = useState(null);
  const [messages, setMessages] = useState([]);
  const [roomId, setRoomId] = useState(null);
  const { socketUrl } = useUrls();

  /** @type {{current: Socket}} socketRef */
  const socketRef = useRef();

  const userTeamId = userTeam?.obj.id;
  const draftMessages = draftMessagesData?.messages;
  const draftId = draftData?.draft.id;
  const username = currentUser?.obj.username;

  useEffect(() => {
    if (userTeamId) setFromTeamId(userTeamId);
  }, [userTeamId]);

  useEffect(() => {
    if (draftMessages) setMessages(draftMessages);
  }, [draftMessages]);

  useEffect(() => {
    if (draftId) setRoomId(draftId);
  }, [draftId, setRoomId]);

  useEffect(() => {
    if (roomId && username) {
      // noinspection JSCheckFunctionSignatures
      socketRef.current = io(socketUrl, {
        query: { roomId, username },
      });

      socketRef.current.on("connect", () => {
        console.log("(socket) on - connect", socketRef.current.id);

        // noinspection JSCheckFunctionSignatures
        console.log(`(socket) emit - draft:helloFromClient`);
        socketRef.current.emit("draft:helloFromClient", "hello from client");
      });

      socketRef.current.on("draft:hello", (data) => {
        console.log(
          `(socket) on - draft:hello - message received from server: ${data}`
        );
      });

      socketRef.current.on("draft:newMessage", (message) => {
        console.log(`(socket) on - draft:newMessage - with message:`, message);
        setMessages((messages) => [...messages, message]);
      });

      socketRef.current.on("disconnect", () => {
        console.log("(socket) on - disconnect", socketRef.current.id);
      });
    }

    return () => {
      if (socketRef.current) socketRef.current.disconnect();
    };
  }, [roomId, username, socketUrl]);

  const sendMessage = (content) => {
    if (!socketRef.current) return;
    const payload = {
      username,
      draftId,
      content,
      fromTeamId,
    };

    console.log(`(socket) emit - draft:addMessage - with payload: `, payload);
    // noinspection JSCheckFunctionSignatures
    socketRef.current.emit("draft:addMessage", payload);
  };

  return { messages, sendMessage };
}
